import React from 'react';
import Box from '../components/Box';

export const AboutThdjbr = () => {
  return (
    <Box style={{ background: '#F8F8F8' }}>
      <ul className='pl3'>
          <li className='mb2'>We have decided not to release this dapp due to the difficulty of safely storing private keys without losing those by accident and have to migrate Ethereum to Ethereum 2.0 as the a remaining task.  However, in the beta version, you can borrow a Jabra by multiples of 30 minutes by spending costs, i.e. Ethereum.</li>
          <li className='mb2'>Note that you must wait for several tens of seconds or a few minutes until our dapp saves your transactions in the blockchain.   Ethereum 2.0 could resolve this latency by Beacon chain, Sharding chain, and eWASM.</li>
      </ul>
    </Box>
  )
}

export default AboutThdjbr;
